import {
  productProjectionFragment,
  productProjectionVariantFragment,
} from '@/graphql/fragments/productProjection';
import { ProductProjectionResult, WithAllVariants } from '@/utils/productProjection';

export interface ProductsByKeysVariables {
  /** e.g. `key:${keys.join(',')}` */
  keys: string;
  locale?: 'en';
  limit: number;
}

export type ProductsByKeysResult = Extract<ProductProjectionResult, WithAllVariants>;

export interface ProductsByKeysResponse {
  data: {
    productProjectionSearch: {
      results: ProductsByKeysResult[];
    };
  };
}

export const ProductsByKeys = `query Products($keys: String!, $limit: Int!, $locale: Locale = "en") {
  productProjectionSearch(
    filters: [
      { string: $keys },
      { string: "variants.attributes.active:true" }
    ],
    limit: $limit,
    markMatchingVariants: true
  ) {
    results {
      allVariants(onlyMatching: true) {
        ...productProjectionVariantFragment
      }
      ...productProjectionFragment
    }
  }
}

${productProjectionFragment}

${productProjectionVariantFragment}
`;
